var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.478 0.311523L9.20742 1.58213L11.2654 3.6312H1.78959C0.801231 3.6312 0 4.43244 0 5.42079V8.10517H1.78959V5.42079H11.2654L9.21636 7.46986L10.478 8.73152L14.0572 5.15235C14.4041 4.80333 14.4041 4.23972 14.0572 3.89069L10.478 0.311523Z",
  fill: "#6464E1"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.5278 12.5793H3.05197L5.10104 10.5302L3.83939 9.26855L0.260217 12.8477C-0.086739 13.1968 -0.086739 13.7604 0.260217 14.1094L3.83939 17.6886L5.10104 16.4269L3.05197 14.3689H12.5278C13.5162 14.3689 14.3174 13.5676 14.3174 12.5793V9.89491H12.5278V12.5793Z",
  fill: "#6464E1"
});

function SvgIconChange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChange);
export default __webpack_public_path__ + "static/media/icon-change.7ceb1834b62d5bad419fbf46d04e83d0.svg";
export { ForwardRef as ReactComponent };